export enum UpdateEventStatusErrorEnum {
  UPDATE_STATUS_EVENT_FAILED_HAS_TICKETS = 'UPDATE_STATUS_EVENT_FAILED_HAS_TICKETS',
  UPDATE_STATUS_EVENT_FAILED_DATE_PAST = 'UPDATE_STATUS_EVENT_FAILED_DATE_PAST',
  UPDATE_STATUS_EVENT_FAILED = 'UPDATE_STATUS_EVENT_FAILED',
}
